import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import UpgradeButton from './components/UpgradeButton';

const SubscriptionCanceled: React.FC = () => {
    const { isFree } = useAuth();

    return (
        <div className="container">
            <div className="canceled-page">
                <div className="canceled-state">
                    <span className="canceled-icon">😔</span>
                    <h1>Subscription Canceled</h1>
                    <p>You've canceled the subscription upgrade process. No payment has been made.</p>
                    
                    <div className="what-happened">
                        <h3>What happened?</h3>
                        <p>
                            You were in the process of upgrading to our Pro plan but decided to cancel. 
                            That's perfectly fine! Your account remains unchanged.
                        </p>
                    </div>

                    {isFree && (
                                        <div className="free-reminder">
                    <h3>You're still on the Free plan</h3>
                            <p>
                                You can continue using your free account with the current limitations, 
                                or upgrade to Pro anytime to unlock all features.
                            </p>
                            
                            <div className="free-benefits">
                                <h4>What you get with Pro:</h4>
                                <ul className="benefits-list">
                                    <li>✅ Unlimited searches</li>
                                    <li>✅ Advanced analytics</li>
                                    <li>✅ Priority support</li>
                                    <li>✅ Export capabilities</li>
                                    <li>✅ Full access to all features</li>
                                </ul>
                            </div>

                            <div className="upgrade-option">
                                <h4>Ready to upgrade?</h4>
                                <UpgradeButton size="large" variant="primary" showBenefits={false} />
                            </div>
                        </div>
                    )}

                    <div className="action-buttons">
                        <Link to="/content-search" className="primary-button">
                            Continue Using App
                        </Link>
                        <Link to="/bonds" className="secondary-button">
                            Browse Bonds
                        </Link>
                    </div>

                    <div className="support-section">
                        <h3>Need Help?</h3>
                        <p>
                            If you have questions about our pricing or features, feel free to contact our support team.
                        </p>
                        <div className="support-options">
                            <a href="mailto:support@lularge.com" className="support-link">
                                📧 Email Support
                            </a>
                            <Link to="/help" className="support-link">
                                📚 Help Center
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCanceled; 